import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { DetailPageTitle } from 'src/common/components/AppLayout/DetailsPage/DetailsPageTitle';
import { PageLayout } from 'src/common/components/AppLayout/PageLayout';
import { Routes } from 'src/Routes.constants';

type ESimDetailsRoutingParams = {
  eid?: string;
};

const ESimProductDetailsTabsLayout = () => {
  const { t } = useTranslation();
  const { eid } = useParams<ESimDetailsRoutingParams>();

  return (
    <DetailPageTitle
      title={t('products.eSim.details.title', {
        eid: eid,
      })}
      rootLocation={{
        to: Routes.esim,
        name: t('products.eSim.details.rootLocationName'),
      }}
      currentLocationName={t('products.eSim.details.locationName')}
    />
  );
};
export const ESimDetailsPageLayout = ({ children }: { children: React.ReactNode }) => {
  return <PageLayout title={<ESimProductDetailsTabsLayout />}>{children}</PageLayout>;
};
